(function () {
  const header = document.querySelector(".el-header");
  if (!header) return;

  const menuBtn = header.querySelector(".el-header__menu-nav");
  const overlay = header.querySelector(".el-header__overlay");
  const drawer = header.querySelector(".el-header__drawer");
  const closeBtn = header.querySelector(".el-header__menu-close");
  const body = document.body;

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add("is-open");
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add("is-visible"));
    body.classList.add("el-header-no-scroll");
    if (menuBtn) menuBtn.setAttribute("aria-expanded", "true");
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-visible");
    body.classList.remove("el-header-no-scroll");
    if (menuBtn) menuBtn.setAttribute("aria-expanded", "false");
    window.setTimeout(() => {
      if (!drawer.classList.contains("is-open")) overlay.hidden = true;
    }, 300);
  }

  if (menuBtn) menuBtn.addEventListener("click", openDrawer);
  if (overlay) overlay.addEventListener("click", closeDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeDrawer();
  });

  function updateStickyState() {
    if (window.scrollY > 40) {
      header.classList.add("el-header--sticky");
    } else {
      header.classList.remove("el-header--sticky");
    }
  }

  updateStickyState();
  window.addEventListener("scroll", updateStickyState, { passive: true });

  function cartJsUrl() {
    if (window.Shopify?.routes?.root) {
      return `${window.Shopify.routes.root.replace(/\/?$/, "/")}cart.js`;
    }
    return "/cart.js";
  }

  function updateCartCount(count) {
    const cartLinks = document.querySelectorAll(".el-header__cart");
    if (!cartLinks.length) return;

    let itemCount = typeof count === "number" ? count : parseInt(String(count), 10);
    if (!Number.isFinite(itemCount) || itemCount < 0) itemCount = 0;

    cartLinks.forEach((cartLink) => {
      let bubble = cartLink.querySelector(".el-header__cart-count");
      if (itemCount === 0) {
        if (bubble) bubble.remove();
        cartLink.setAttribute("aria-label", "Cart");
        return;
      }

      if (!bubble) {
        bubble = document.createElement("span");
        bubble.className = "el-header__cart-count";
        cartLink.appendChild(bubble);
      }
      bubble.textContent = String(itemCount);
      cartLink.setAttribute("aria-label", `Cart (${itemCount})`);
    });
  }

  function itemCountFromCart(cart) {
    if (!cart) return null;
    if (cart.item_count != null) return cart.item_count;
    if (Array.isArray(cart.items)) {
      return cart.items.reduce((sum, line) => sum + (parseInt(String(line?.quantity), 10) || 0), 0);
    }
    return null;
  }

  function syncFromEvent(event) {
    const cart = event?.detail?.cart;
    const count = itemCountFromCart(cart);
    if (count == null) return;
    requestAnimationFrame(() => updateCartCount(count));
  }

  function syncFromServer() {
    fetch(cartJsUrl())
      .then((res) => res.json())
      .then((data) => updateCartCount(itemCountFromCart(data) || 0))
      .catch(() => {});
  }

  document.addEventListener("cart:updated", syncFromEvent);
  document.addEventListener("cart:change", syncFromEvent);
  document.addEventListener("cart:refresh", syncFromServer);
})();
